import { render } from "./paginaTreinador.vue?vue&type=template&id=4a7409f9"
import script from "./paginaTreinador.vue?vue&type=script&lang=js"
export * from "./paginaTreinador.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__